import React from "react";

const items = [
  "Legend", "Challonge", "XSplit", "Rejuven", "Big 7 Media",
  "Player.me", "Canvid", "Videocom", "VCam", "Mist Media",
  "Creator Tools", "Esports", "AI Technology", "Digital Health", "Film & TV",
];

export default function Marquee() {
  return (
    <div
      className="relative py-6 overflow-hidden border-y border-white/[0.04] bg-charcoal/50"
      data-testid="marquee-section"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {/* Duplicate items for seamless loop */}
        {[...items, ...items].map((item, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-4 mx-6 whitespace-nowrap"
          >
            <span className="text-xs uppercase tracking-[0.2em] font-mono text-white/15 hover:text-cyan-accent/40 transition-colors duration-500">
              {item}
            </span>
            <span className="w-1 h-1 rounded-full bg-cyan-accent/20" />
          </span>
        ))}
      </div>
    </div>
  );
}
